import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldDate from '../../components/plain/FieldDate';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldReference from '../../components/plain/FieldReference';

import {CLASS_ORDER, CLASS_LIBRARY, CLASS_OFFER } from '../../util/consts/classes';
import {FORM_ORDER_PLAIN, FORM_LIBRARY_TABLE, FORM_OFFER_TABLE} from '../../util/consts/forms';
import {LIBRARY_PLAIN_PATH, OFFER_PLAIN_PATH} from '../../util/routes';

class OrderPlainPage extends PlainPage {
	
	constructor(props) {
		super(props);
		this.formPath = FORM_ORDER_PLAIN;
		this.formTitle = 'Обране';
		this.buildInstanceCard = this.buildOrderCard;
	}
	componentDidMount = async () => {
		this.init( CLASS_ORDER );
		document.title = 'BOM. ' + this.formTitle;
	}
	buildOrderCard = (orderInstance) => {
		let card = '';
		if( orderInstance.rootField.value.offerRef.value ) {
			let offerCard = orderInstance.rootField.value.offerRef.value.card;
			if( offerCard )
				card += offerCard;
		}
		return card;
	}
	
	renderBody() {
		let instance = this.state.instance;
		let fieldGroup = instance.rootField;
		let readOnly = this.instanceReadOnly;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >

					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldReference instance={instance} path={'libraryRef'} parentField={fieldGroup} plain={this} 
							readOnly={readOnly}
							styles={{ divMain: {marginRight: '20px', flexGrow: '1'} }}
							refNodes={[
								{
									classId: CLASS_LIBRARY, plainFormPath: LIBRARY_PLAIN_PATH, 
									selectInstanceFormId: FORM_LIBRARY_TABLE,
									selectInstanceFormTitle: 'Бібліотеки'
								},
							]}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldReference instance={instance} path={'offerRef'} parentField={fieldGroup} plain={this} 
							readOnly={readOnly}
							styles={{ divMain: {marginRight: '20px', flexGrow: '1'} }}
							refNodes={[
								{
									classId: CLASS_OFFER, plainFormPath: OFFER_PLAIN_PATH, 
									selectInstanceFormId: FORM_OFFER_TABLE,
									selectInstanceFormTitle: 'Пропозиції'
								},
							]}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldDate instance={instance} path={'date'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '0', marginRight: '20px'} }}
						/>
						<FieldInteger ref={this.refQty} instance={instance} path={'qty'} parentField={fieldGroup} plain={this} 
							readOnly={true}
							styles={{ input: {width: '50px', marginRight: '20px'} }}
						/>
						<FieldDecimal ref={this.refAmount} instance={instance} path={'price'} parentField={fieldGroup} plain={this} 
							readOnly={true}
							styles={{ input: {width: '50px'} }}
						/>
					</div>
				</div>					
			</div>
		)
	}
}

export default OrderPlainPage;
